import axios from "axios";

const uploadImage = (params) => axios.post(`/api/v1/pages/images`, params);

// A task description is written with the same editor as an article (LF360-1852),
// so its media takes the same road — the owner in the body is what differs.
const uploadTaskImage = ({ dailyTaskId, base64, mimeType }) =>
  axios.post('/api/v1/pages/images', { dailyTaskId, base64, mimeType });

const uploadLegalDocImage = ({ legalDocumentId, base64, mimeType }) => {
  return axios.post('/api/v1/legal-documents/images', {
    legalDocumentId,
    base64,
    mimeType
  });
};

const deleteImage = (articleId, id, params) => axios.post(`/api/v1/pages/${articleId}/images/${id}`, params);

const uploadVideo = (params) => {
  return axios.post("/api/v1/pages/videos", params);
};

const getSignedUrls = (params) => axios.post(`/api/v1/user-uploads/get-signed-urls`, params);

const ApiUserUploads = {
  uploadImage,
  deleteImage,
  getSignedUrls,
  uploadLegalDocImage,
  uploadTaskImage,
  uploadVideo
};

export default ApiUserUploads;
